import { StoreTeacher } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData } from "@/helpers/global";
import { StudentTeacherService } from "@/services/api/student-teacher";

const module = {
    namespaced: true,
    timer: {
        by: new WaitTimer(StoreTeacher.state.by, 24 * 60 * 60),
    },
    state: () => ({
        by: null,
    }),
    mutations: {
        set(state, data) {
            if (state.by != data) {
                state.by = data;
            }
        },
    },
    actions: {
        set(ctx, data) {
            ctx.commit("set", data);
            module.timer.by.resetLastFetchTime();
        },
        load({ state, dispatch }, p) {
            if (p.detect && state.by) {
                if (module.timer.by.getLastFetchTime() < p.detect) {
                    p.reset = true;
                }
                else {
                    return;
                }
            }
            if (!state.by || p.reset || module.timer.by.isTimeExpired(module.timer.by.timeOut)) {
                StudentTeacherService.ByTeacher(function (data) {
                    dispatch("set", data);
                    p.callback();
                }, p.wait);
            }
            else {
                p.wait();
                p.callback();
            }
        },
    },
    getters: {
        get(state) {
            return state.by;
        },
    }
};
export default module;